// extracted by mini-css-extract-plugin
export default {"app_widget_bar":"AppWidgetBar_app_widget_bar__saX0m"};